// extracted by mini-css-extract-plugin
export default {"container":"TradeList_container__S8-2o","title":"TradeList_title__R6PQ5","tradeItem":"TradeList_tradeItem__+dfy7","tradeTitle":"TradeList_tradeTitle__Vjquu"};